import { render, staticRenderFns } from "./ProviderHome.vue?vue&type=template&id=04f10af6"
import script from "./ProviderHome.vue?vue&type=script&setup=true&lang=js"
export * from "./ProviderHome.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProviderHome.vue?vue&type=style&index=0&id=04f10af6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports